import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { LocationType } from '../../global.constants';
import { ActionSource } from '../../state/action-sources';

export const NewOpportunityLocationsActions = createActionGroup({
	source: ActionSource.NEW_OPPORTUNITY_LOCATIONS,
	events: {
		'Google Autocomplete Input Changed': props<{
			address: string;
			locationType: LocationType;
		}>(),
		'Google Autocomplete Address Selected': props<{
			address: google.maps.places.PlaceResult;
			locationType: LocationType;
			openWizard?: boolean;
		}>(),
		'Add Location Manually Button Clicked': props<{
			locationType: LocationType;
		}>(),
		'Exit Minimal View Button Clicked': emptyProps(),
	},
});
